import React from 'react'

function Onas() {
  return (
    <div>Onas</div>
  )
}

export default Onas